import React, { useEffect, useRef, useState } from 'react'

const SelectInputBase = Component =>
  function Wrapped(props) {
    const {
      options,
      multiple,
      disabled,
      value = multiple ? [] : '',
      onClose,
    } = props

    const selectInputRef = useRef()
    const searchInputRef = useRef(null)
    const [selectedValue, setSelectedValue] = useState(value)
    const [searchQuery, setSearchQuery] = useState('')
    const [filteredOptions, setFilteredOptions] = useState(options)
    const isEmptySelect = multiple
      ? !selectedValue.length
      : !options.find(option => option.value === value)

    useEffect(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus()
      }
    }, [searchQuery])

    useEffect(() => {
      setFilteredOptions(options)
    }, [JSON.stringify(options)])

    useEffect(() => {
      setSelectedValue(value)
    }, [JSON.stringify(value)])

    const onCloseSelectInput = () => {
      if (selectInputRef && selectInputRef.current) {
        selectInputRef.current.classList.remove('Mui-focused')
      }

      setSearchQuery('')
      setFilteredOptions(options)

      if (onClose) {
        onClose(selectedValue)
      }
    }

    return (
      <Component
        {...props}
        selectInputRef={selectInputRef}
        searchInputRef={searchInputRef}
        selectedValue={selectedValue}
        setSelectedValue={setSelectedValue}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        filteredOptions={filteredOptions}
        setFilteredOptions={setFilteredOptions}
        isEmptySelect={isEmptySelect}
        isSelectInputDisabled={disabled}
        onCloseSelectInput={onCloseSelectInput}
      />
    )
  }

export default SelectInputBase
